// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2HjvT","rootSmall":"AddTileButton_rootSmall__3uZbN"};